export const GAM_ASSET_NOTAUTHORIZED = 'ASSET_NOTAUTHORIZED';
export const GAM_CONSUMER_NOTFOUND = 'CONSUMER_NOTFOUND';
export const GAM_DEVICEID_NOTFOUND = 'DEVICEID_NOTFOUND';
export const GAM_ASSET_NOTFOUND = 'ASSET_NOTFOUND';
export const GAM_ACTION_NOTAUTHORIZED = 'ACTION_NOTAUTHORIZED';

export const GAM_FW_ERROR_BAD_REQUEST = 'GAM_FW_ERROR_BAD_REQUEST';
